// @flow
/* ***************************************************************************
* @author Afonso Bordado (abordado@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import {
  formatCurrency,
  formatDate,
  formatDateToShortDate,
} from "../../utils"
import SimpleTable from "../SimpleTable"
import Hidable from "../Hidable"
import style from "./styles.css"
import { connect } from "react-redux"
import Button from "react-toolbox/lib/button"
import CreateInvoice from "../../components/CreatePaymentAgreementComponents/CreateInvoice2"
import CreateContract from "../../components/DebtPhaseContracts/CreateContract"
import Dialog from "react-toolbox/lib/dialog"
import * as strings from "../../strings"
import _ from "lodash"
import { toastr } from "react-redux-toastr"
import {
  addContract,
  updateContractById,
  removeContractById,
  addInvoice,
  updateInvoiceById,
  removeInvoiceById,
} from "../../actions"

type Contract = {
  id: number,
  contractNumber: string,
  startDate: Date,
  endDate: Date,
  invoices: Invoice[],
}

type Invoice = {
  id: number,
  idContract: number,
  value: string,
  date: Date,
  expiryDate: Date,
  documentNumber: string,
}


const INVOICE_COLUMNS = {
  contractNumber: { title: strings.paymentAgreements.contractNumber, align: "left", width: "20%" },
  documentNumber: { title: strings.paymentAgreements.documentNumber, align: "left", width: "20%" },
  value: { title: strings.invoices.invoiceValue, align: "left", width: "20%" },
  date: { title: strings.invoices.emissionDate, align: "left", width: "20%" },
  expiryDate: { title: strings.invoices.expiryDate, align: "left", width: "20%" },
}


class DebtPhaseContracts extends Component {
  props: {
    resetFunc: () => any,
    processId: any,
    contracts: Contract[],
    expanded?: boolean,
    onToggle?: () => any,
    addContract: any,
    updateContractById: any,
    removeContractById: any,
    addInvoice: any,
    updateInvoiceById: any,
    removeInvoiceById: any,
    auth: {
      token: string,
    },
  }

  state = {
    addActive: false,
    editActive: false,
    contractDialog: false,
    newInvoice: {
      documentNumber: undefined,
      value: undefined,
      date: undefined,
      expiryDate: undefined,
      idContract: undefined,
    },
    newContract: {
      contractNumber: undefined,
      date: undefined,
      startDate: undefined,
      endDate: undefined,
      address: undefined,
    },
    areInvoiceFieldsInvalid: [ false, false, false, false, false ],
    areContractFieldsInvalid: [ false, false, false, false ],
    contracts: [],
    buttonsContract: [],
    buttonsInvoice: [],
  }

  /** **********************************************************************************************
  // Contract                                                                                      *
  *************************************************************************************************/

  deleteContract = async () => {
    const id = this.state.newContract.id
    const processId = Object.values( this.props.processId )[ 0 ]

    let response = await removeContractById( this.props.auth.token, id )

    this.props.resetFunc( processId )

    response.message === "OK" ?
      toastr.success( strings.invoices.contractSuccessfullyDeleted ) :
      toastr.error( strings.errorMessages.anErrorHasOccurred )


    this.setState( {
      contractDialog: false,
    } )
  }

  handleChangeContract = ( event ) => {
    return this.setState( {
      newContract: {
        ...this.state.newContract,
        ...event,
      },
    } )
  }

  handleSubmitContract = async () => {
    const contract = { ...this.state.newContract, ...this.props.processId }
    const fieldValidation = this.checkContract( contract )

    if ( fieldValidation.every( value => value === false ) ) {
      const processId = Object.values( this.props.processId )[ 0 ]

      let func = contract.id ? updateContractById : addContract




      const PreparedContract = {
        ...contract,
        date: formatDateToShortDate( contract.date ),
        startDate: formatDateToShortDate( contract.startDate ),
        endDate: formatDateToShortDate( contract.endDate ),
      }

      const response = await func( this.props.auth.token, PreparedContract )

      if ( response.message !== "OK" ) {
        toastr.error( strings.errorMessages.anErrorHasOccurred )
      } else {
        toastr.success( strings.generalStrings.changesSaved )
      }

      this.props.resetFunc( processId )

      this.setState( {
        contractDialog: false,
      } )
    } else {
      this.setState( {
        areContractFieldsInvalid: fieldValidation,
      } )
    }
  }

  checkContract = ( contract ) => {
    let areContractFieldsInvalid = []
    _.forEach( contract, function ( value ) {
      areContractFieldsInvalid.push( value === undefined || value === "" )
    } )
    return areContractFieldsInvalid
  }

  toggleContractDialog = ( contract = undefined ) => () => {

    let buttons = [
      { label: strings.generalStrings.cancel, onClick: this.toggleContractDialog() },
      { label: strings.generalStrings.submit, onClick: this.handleSubmitContract },
    ]

    if ( contract === undefined ) {
      contract = {
        contractNumber: undefined,
        date: undefined,
        startDate: undefined,
        endDate: undefined,
        address: undefined,
      }
    } else {
      contract = {
        contractNumber: contract.contractNumber,
        date: new Date( contract.date ),
        startDate: new Date( contract.startDate ),
        endDate: new Date( contract.endDate ),
        address: contract.address,
        id: contract.id,
      }
      buttons = [ { label: strings.generalStrings.delete, onClick: this.deleteContract }, ...buttons ]
    }

    this.setState( {
      buttonsContract: buttons,
      areContractFieldsInvalid: [ false, false, false, false ],
      contractDialog: !this.state.contractDialog,
      newContract: {
        ..._.omit( this.state.newContract, [ "id" ] ),
        ...contract,
      },
    } )
  }

  renderContractDialog = ( submitFunction, active ) => {

    const { state } = this
    return (
      <Dialog
        actions={ state.buttonsContract }
        className={style.dialogBoxFormat}
        active={active}
        onEscKeyDown={this.toggleContractDialog()}
        onOverlayClick={this.toggleContractDialog()}>
        <CreateContract areInputFieldsInvalid={state.areContractFieldsInvalid}
          newContract={state.newContract} onChange={this.handleChangeContract} />
      </Dialog>
    )
  }


  /** **********************************************************************************************
  // Invoice                                                                                      *
  *************************************************************************************************/
  handleChangeInvoice = ( event ) => {
    return this.setState( {
      newInvoice: {
        ...this.state.newInvoice,
        ...event,
      },
    } )
  }

  closeInvoice = ( ) => () => {
    this.setState( {
      addActive: false,
      editActive: false,
      newInvoice: {
        documentNumber: undefined,
        value: undefined,
        date: undefined,
        expiryDate: undefined,
        idContract: undefined,
      },
      areInvoiceFieldsInvalid: [ false, false, false, false, false ],
    } )
  }

  checkInvoice = ( invoice ) => {
    let areInvoiceFieldsInvalid = []
    _.forEach( invoice, function ( value ) {
      areInvoiceFieldsInvalid.push( value === undefined || value === "" )
    } )
    return areInvoiceFieldsInvalid
  }

  handleSubmitInvoice = async () => {
    const invoice = this.state.newInvoice
    const fieldValidation = this.checkInvoice( invoice )

    if ( fieldValidation.every( value => value === false ) ) {

      const processId = Object.values( this.props.processId )[ 0 ]

      const func = invoice.id ? updateInvoiceById : addInvoice

      const response = await func( this.props.auth.token, invoice )

      this.closeInvoice()()

      if ( response.message !== "OK" ) {
        toastr.error( strings.errorMessages.anErrorHasOccurred )
      } else {
        toastr.success( strings.generalStrings.changesSaved )
      }

      this.props.resetFunc( processId )

    } else {
      this.setState( {
        areInvoiceFieldsInvalid: fieldValidation,
      } )
    }
  }

  deleteInvoice = async () => {
    const id = this.state.newInvoice.id
    const processId = Object.values( this.props.processId )[ 0 ]

    let response = await removeInvoiceById( this.props.auth.token, id )

    this.props.resetFunc( processId )

    response.message === "OK" ?
      toastr.success( strings.invoices.invoiceSuccefullyDeleted ) :
      toastr.error( strings.errorMessages.anErrorHasOccurred )

    this.closeInvoice()()
  }

  openEditInvoice = ( invoice, id ) => () => {
    const buttons = [
      { label: strings.generalStrings.delete, onClick: this.deleteInvoice },
      { label: strings.generalStrings.cancel, onClick: this.closeInvoice( ) },
      { label: strings.generalStrings.submit, onClick: this.handleSubmitInvoice },
    ]
    this.openInvoiceDialog( true )()
    this.setState( {
      buttonsInvoice: buttons,
      newInvoice: {
        documentNumber: invoice.documentNumber,
        value: parseFloat( invoice.value ).toString(),
        date: new Date( invoice.date ),
        expiryDate: new Date( invoice.expiryDate ),
        idContract: id,
        id: invoice.id,
      },
    } )
  }

  prepareDialogState = ( isEdit ) => {
    const addActive = isEdit ? this.state.addActive : !this.state.addActive
    const editActive = isEdit ? !this.state.editActive : this.state.editActive
    return {
      addActive,
      editActive,
    }
  }

  openInvoiceDialog = ( isEdit ) => () => {
    const buttons = [
      { label: strings.generalStrings.cancel, onClick: this.closeInvoice( ) },
      { label: strings.generalStrings.submit, onClick: this.handleSubmitInvoice },
    ]

    return this.setState( {
      buttonsInvoice: buttons,
      ...this.prepareDialogState( isEdit ),
    } ) }

  renderInvoiceDialog = ( submitFunction, active ) => {

    const { state } = this
    return (
      <Dialog
        actions={ state.buttonsInvoice}
        className={style.dialogBoxFormat}
        active={active}
        onEscKeyDown={this.closeInvoice( )}
        onOverlayClick={this.closeInvoice( )}>
        <CreateInvoice areInputFieldsInvalid={state.areInvoiceFieldsInvalid}
          newInvoice={state.newInvoice} contracts={state.contracts} onChange={this.handleChangeInvoice} />
      </Dialog>
    )
  }

  componentWillReceiveProps ( nextProps ) {
    const contractNumbers = nextProps.contracts.map( contract => {
      return { value: contract.id, label: contract.contractNumber }
    } )

    if ( !_.isEqual( this.props.contracts, nextProps.contracts ) ) {
      this.setState( {
        contracts: contractNumbers,
      } )
    }
  }

  componentWillMount () {
    const contractNumbers = this.props.contracts.map( contract => {
      return { value: contract.id, label: contract.contractNumber }
    } )

    this.setState( {
      contracts: contractNumbers,
    } )
  }

  render () {
    const { contracts } = this.props
    if ( !contracts ) {
      return <div />
    }

    const formattedContracts = _.flatten( contracts.map( contract => {
      const formattedInvoices = contract.invoices
        .map( invoice => ( {
          documentNumber: invoice.documentNumber,
          date: formatDate( invoice.date ),
          expiryDate: formatDate( invoice.expiryDate ),
          value: formatCurrency( invoice.value ),
          _onClick: this.openEditInvoice( invoice, contract.id ),
        } ) )

      return [ { contractNumber: contract.contractNumber, _onClick: this.toggleContractDialog( contract ) }, ...formattedInvoices ]
    } ) )

    return (
      <Hidable
        title="Faturas"
        expanded={this.props.expanded}
        onToggle={this.props.onToggle}
      >

        {this.renderInvoiceDialog( this.handleSubmitInvoice, this.state.addActive ) }
        {this.renderInvoiceDialog( this.handleSubmitInvoice, this.state.editActive ) }

        {this.renderContractDialog( this.handleSubmitContract, this.state.contractDialog ) }
        <SimpleTable sortable={false} columns={INVOICE_COLUMNS} data={formattedContracts} />
        <div className={style.buttonContainer}>
          <Button onClick={this.toggleContractDialog( )} icon="add" raised primary>{strings.paymentAgreements.addContract}</Button>
          <Button onClick={this.openInvoiceDialog( false )} icon="add" raised primary>{strings.invoices.addInvoice}</Button>
        </div>
      </Hidable>
    )
  }
}

export default connect(
  store => ( { auth: store.auth } ),
  {
    addContract,
    updateContractById,
    removeContractById,
    addInvoice,
    updateInvoiceById,
    removeInvoiceById,
  } )( DebtPhaseContracts )



// WEBPACK FOOTER //
// ./src/components/DebtPhaseContracts/index.jsx